import client from "../../../services/session/apiClient";

export const checkForGoogleLocationId = (locationId) => {
    return client.post("/v5/listingVerification/google/checkForGoogleLocationId", { locationId })
        .then(resp => resp.data)
}

export const listActiveGoogleVerifications = (listingIds) => {
    return client.post("/v5/listingVerification/google/listActiveGoogleVerifications", { listingIds })
        .then(resp => resp.data)
}

export const listAuthorizedGoogleAccounts = () => {
    return client.get("/v5/listingVerification/google/listAuthorizedGoogleAccounts")
        .then(resp => resp.data)
}

export const findLocationInGoogleAccount = (credentialId, listingId) => {
    return client.post("/v5/listingVerification/google/findLocationInGoogle", {credentialId, listingId})
        .then(resp => resp.data)
}

export const createGoogleLocation = (credentialId, listingId) => {
    return client.post("/v5/listingVerification/google/createLocationInAccount", {credentialId, listingId})
        .then(resp => {
            return resp.data.googleLocation
        })
}

export const createGooglListing = (credentialId, locationId) => {
    return client.post("/v5/listingVerification/google/createListingInAccount", {credentialId, locationId})
        .then(resp => {
            return resp.data.googleLocation
        })
}

export const fetchVerificationMethods = (credentialId, googleLocationId) => {
    return client.post("/v5/listingVerification/google/listAvailableGoogleVerificationMethods", {credentialId, googleLocationId})
        .then(resp => resp.data.options)
}

export const initiateVerification = (credentialId, listingId, googleLocationId, verificationMethod) => {
    return client.post("/v5/listingVerification/google/initiateVerification", {
        credentialId,
        listingId,
        googleLocationId,
        verificationMethod
    })
        .then(resp => resp.data)
}

export const initiateNewListingVerification = (credentialId, googleLocationId, verificationMethod, verificationMethodData) => {
    return client.post("/v5/listingVerification/google/initiateNewListingVerification", {
        credentialId,
        googleLocationId,
        verificationMethod,
        verificationMethodData
    })
    .then(resp => resp.data)
}

export const completeVerification = (verificationId, pin) => {
    return client.post("/v5/listingVerification/google/completeVerification", {
        chatmeterVerificationId: verificationId,
        pin
    })
}